





















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { StreamMetadata } from '@/data/api'

@Component
export default class LCLivestreamCard extends Vue {
  @Prop(String) readonly avatar!: string
  @Prop(String) readonly name!: string
  @Prop(Boolean) readonly ok!: boolean
  @Prop(String) readonly startTime!: string
  @Prop(Object) readonly metadata!: StreamMetadata

  elapsed: number = 0
  iid = 0 // interval ID

  startTimer () {
    this.elapsed = (new Date().getTime() - new Date(this.startTime).getTime()) / 1000
    this.iid = setInterval(() => { this.elapsed += 1 }, 1000)
  }

  stopTimer () {
    if (!this.iid) return
    this.elapsed = 0
    clearInterval(this.iid)
  }

  mounted () {
    if (!this.startTime) return
    this.startTimer()
  }

  @Watch('startTime')
  onStartTimeChange () {
    this.stopTimer()
    this.startTimer()
  }

  beforeDestroy () {
    this.stopTimer()
  }
}
